// this code is for sync main quantity selector and sticky 
document.addEventListener("DOMContentLoaded", () => {
  const primary = document.querySelector(".quantity__input-primary");
  const sticky  = document.querySelector(".quantity__input-sticky");

  if (!primary || !sticky) return;

  const syncValue = () => sticky.value = primary.value;

  ["input", "change"].forEach(evt =>
    primary.addEventListener(evt, syncValue)
  );
});

// Accordion auto-close functionality
document.addEventListener("DOMContentLoaded", () => {
  // Override the AccordionTab open method to add auto-close behavior
  const originalOpen = AccordionTab.prototype.open;
  
  AccordionTab.prototype.open = function() {
    // Store the position of the clicked accordion before closing others
    const clickedAccordionTop = this.getBoundingClientRect().top + window.pageYOffset;
    const clickedSummary = this.querySelector('summary');
    
    // Close other accordions in the same group
    this.closeOtherAccordions();
    
    // Call the original open method
    originalOpen.call(this);
    
    // After a brief delay, adjust scroll position to keep clicked accordion in view
    setTimeout(() => {
      if (clickedSummary) {
        const summaryRect = clickedSummary.getBoundingClientRect();
        const isHeadingInViewport = summaryRect.top >= 0 && summaryRect.bottom <= window.innerHeight;

        if (isHeadingInViewport) {
          return;
        }
      }

      const currentTop = this.getBoundingClientRect().top + window.pageYOffset;
      const scrollAdjustment = currentTop - clickedAccordionTop;
      
      if (Math.abs(scrollAdjustment) > 5) { // Only adjust if significant movement
        window.scrollTo({
          top: window.pageYOffset + scrollAdjustment,
          behavior: 'smooth'
        });
      }
    }, 260); // Slightly after the close animation (250ms)
  };
  
  AccordionTab.prototype.closeOtherAccordions = function() {
    // Find the parent container that holds all accordions
    const parentContainer = this.closest('.product-details') || this.parentElement;
    
    if (parentContainer) {
      // Find all other accordion-tab elements in the same container
      const otherAccordions = parentContainer.querySelectorAll('accordion-tab');
      
      otherAccordions.forEach(accordion => {
        // Skip the current accordion
        if (accordion !== this) {
          // Close the accordion if it's open
          if (accordion.details && accordion.details.open && !accordion.isClosing) {
            // Set overflow hidden before shrinking to hide content during animation
            accordion.details.style.overflow = 'hidden';
            accordion.shrink();
          }
        }
      });
    }
  };
});


document.querySelectorAll('.scroll-to-reviews').forEach(link => {
  link.addEventListener('click', function(e) {
    e.preventDefault();

    const target = document.querySelector('#judgeme_product_reviews');
    const offset = 100; // adjust if you have sticky header

    if (target) {
      const top = target.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  });
});
